import React, { Component } from 'react';
import logo from '../images/logo.png';
import { NavLink } from 'react-router-dom';

class Menu extends Component {

  displayMenu() {
    const el = document.querySelector('.phone-menu');
    if(el.classList.contains('open')) {
      el.classList.remove('open')
      document.querySelector('.menu-circle-list').classList.add('hide');
    } else {
      el.classList.add('open');
      document.querySelector('.menu-circle-list').classList.remove('hide');    
    } 
  }

  render() {
    return (
      <div> 
        <header id="header" className="full-header static-sticky" datastickyclass="not-dark" datastickyoffset="full" datastickyoffsetnegative="200">
          <div id="header-wrap">
            <div className="container clearfix">
              <div id="logo">
                <NavLink to="/" className="standard-logo"><img src={logo} alt="Bootcamp de programacion y cursos de tecnologia"/></NavLink>
              </div>
              <nav id="primary-menu">

                <div className="phone-query phone-menu" onClick={(event) => this.displayMenu(event)}>
                  <div className="menu-line"></div>
                  <div className="menu-line"></div>
                  <div className="menu-line"></div>
                </div>

                <div className="phone-query menu-circle-list hide" data-easing="easeInOutExpo" data-speed="1250" data-offset="65">
                  <div className="menu-circle">
                    <a href="#section-home">
                        Clases
                    </a>
                  </div>
                  <div className="menu-circle">
                    <a href="#section-services">
                        Empresas
                    </a>
                  </div>
                  <div className="menu-circle">
                    <a href="#section-about">
                        Acerca
                    </a>
                  </div>
                  <div className="menu-circle">
                    <a href="#contact">
                        Contácto
                    </a>
                  </div>
                </div>
                <ul className="one-page-menu" data-easing="easeInOutExpo" data-speed="1250" data-offset="65">
                  <li><a href="#section-home" data-href="#section-works"><div>Clases</div></a></li>
                  {/* <li><a href="#section-talent" data-href="#wrapper"><div>Talento</div></a></li> */}
                  <li><a href="#section-services" data-href="#section-services"><div>Empresas</div></a></li>
                  <li><a href="#section-about" data-href="#section-about"><div>Acerca</div></a></li>
                  <li><a href="#contact" data-href="#section-contact"><div>Contácto</div></a></li>
                </ul>
              </nav>
            </div>
          </div>
        </header>
      </div>
    
    );
  }
}

export default Menu;
